export default __webpack_public_path__ + "static/media/work-it.10ac8a9f.png";